export const DAILY_REPORT_TYPE = 'daily'
export const FINANCE_REPORT_TYPE = 'finance'
export const MERCHANT_FINANCE_REPORT_TYPE = 'merchant-finance'
